import { Paper, Tabs } from "@mantine/core";
import { useState } from "react";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import CompareInv from "./CompareInv";
import CompareOrder from "./CompareOrder";
import CompareTBC from "./CompareTBC";

const CompareDataAsiaPOS = () => {
  const [activeTab, setActiveTab] = useState<string | null>("DH");

  return (
    <>
      <div
        style={{
          padding: "0px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="DH">Đối chiếu đơn hàng</Tabs.Tab>
            <Tabs.Tab value="K">Đối chiếu kho</Tabs.Tab>
            <Tabs.Tab value="TBC">Đối chiếu thu báo có</Tabs.Tab>
            {/* <Tabs.Tab value="VT">Đối chiếu vật tư</Tabs.Tab> */}
          </Tabs.List>

          <Tabs.Panel value="DH">
            {activeTab === "DH" && <CompareOrder />}
          </Tabs.Panel>

          <Tabs.Panel value="K">
            {activeTab === "K" && <CompareInv />}
          </Tabs.Panel>
          <Tabs.Panel value="TBC">
            {activeTab === "TBC" && <CompareTBC />}
          </Tabs.Panel>
          {/* <Tabs.Panel value="VT">
            {activeTab === "VT" && <CompareVT />}
          </Tabs.Panel> */}
        </Tabs>
      </Paper>
    </>
  );
};

export default CompareDataAsiaPOS;
